module.exports = __webpack_public_path__ + "a3d4419ba08e31c3da4f9cb151fd5bcf.svg";